import { getTrackOffice } from '@/api/track';

import Menu from '../components/menu';
import Bmap from '../components/map';
import { isArray } from '@/utils/is';

export default {
  components: { Menu, Bmap },
  data() {
    return {
      isCollapse: true
    };
  },
  methods: {
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    async getOffice() {
      const res = await getTrackOffice({ busiType: 1 });
      if (isArray(res.data)) {
        this.menus.push(...res.data);
      }
    }
  },
  created() {
    this.getOffice();
  }
};
